import * as Yup from "yup";
import { REQUIRED_FIELD, REQUIRED_SELECTBOX } from "../../../common/validation";

export const CitySchema = (UserRole) =>
  Yup.object().shape({
    city: REQUIRED_FIELD,
    state: Yup.object().shape({
      value: Yup.string().required("State is required!"), // ✅ Ensure 'value' is required
    }),
    state: Yup.object().shape({
      value: Yup.string().required("State is required!"), // ✅ Ensure 'value' is validated
    }),
    rrb:
      UserRole === "control-admin"
        ? Yup.object()
            .shape({
              value: Yup.string().required("RRB is required"),
            })
            .nullable()
        : Yup.mixed().notRequired(),
  });
